import { ButtonV2, Flex } from '@withjoy/joykit';
import React from 'react';

import RegistryAdvisorMobile from '@apps/registry/common/components/RegistryGiftCounts/RegistryAdvisorMobile';
import { useEventInfo } from '@shared/utils/eventInfo';
import { Page } from '@apps/registry/common/components/RegistryGiftCounts/telemetry';
import { useTranslation } from '@shared/core';

interface RegistrySheetExpandedProps {
  handleDismiss: () => void;
  handleAddGifts: () => void;
  page: Page;
}

const RegistrySheetExpanded: React.FC<RegistrySheetExpandedProps> = ({ handleDismiss, handleAddGifts, page }) => {
  const { eventInfo, eventHandle } = useEventInfo();
  const { t } = useTranslation('sharedRegistry');
  const { addGiftCtaLabel, maybeLaterCta } = t('registryPromo');

  if (!eventInfo?.eventId || !eventHandle) {
    return null;
  }
  return (
    <Flex flexDirection="column">
      <RegistryAdvisorMobile
        eventHandle={eventHandle}
        eventId={eventInfo.eventId}
        page={page}
        hideGiftStatusAndPricePointCounters={true}
      />
      <ButtonV2
        intent="newPrimary"
        shape="rounded"
        marginTop={9}
        onClick={handleAddGifts}
      >
        {addGiftCtaLabel()}
      </ButtonV2>
      <ButtonV2
        intent="neutral"
        variant="ghost"
        shape="rounded"
        marginTop={5}
        onClick={handleDismiss}
      >
        {maybeLaterCta()}
      </ButtonV2>
    </Flex>
  );
};

export default RegistrySheetExpanded;
